import { commandsStore } from "@/store/commandsStore";
import {
	isAuctionCommandWithUnsafeTargeting,
	isIncomingCommand,
	isObjectWithCallback,
} from "@/ts/guards";
import type { BaseModule } from "@/ts/module";
import type { CommandCallback, IncomingCommand } from "@/ts/types";
import { normalizeSlots } from "@/utils/slots";

export class CommandQueue implements BaseModule {
	name = "CommandQueue" as const;

	async init(): Promise<void> {
		let realQueue: IncomingCommand[] = [];

		if (window.hydra) {
			realQueue = window.hydra;

			while (realQueue.length > 0) {
				const cmd = realQueue.shift();
				if (cmd) {
					addCommandToStore(cmd);
				}
			}
		}

		const traceMethods: Array<keyof IncomingCommand[]> = ["push"];
		const proxiedQueue = new Proxy(realQueue, {
			get(target: IncomingCommand[], prop: keyof IncomingCommand[] & string) {
				if (traceMethods.includes(prop)) {
					return (item: IncomingCommand) => {
						addCommandToStore(item);
					};
				}
				return target[prop];
			},
		});

		window.hydra = proxiedQueue;
	}
}

const addCommandToStore = (
	commandToAdd: IncomingCommand | CommandCallback,
): void => {
	const normalized = isAuctionCommandWithUnsafeTargeting(commandToAdd)
		? { ...commandToAdd, slots: normalizeSlots(commandToAdd.slots) }
		: commandToAdd;

	if (isIncomingCommand(normalized)) {
		const { actions } = commandsStore.getState();
		actions.addCommand(normalized);
	} else if (isObjectWithCallback(normalized)) {
		normalized.callback();
	}
};
